import axios from 'axios';
import { UserProfile, PublicUser } from '../types/user.types';
import config from '../config/env.config';

const API_URL = config.API_URL;

// Configure axios for httpOnly cookies
const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Include httpOnly cookies
});

export const userService = {
  // Get current user profile
  getCurrentUserProfile: () => {
    return apiClient.get<UserProfile>('/user/profile');
  },

  // Update current user profile
  updateUserProfile: (data: { displayName?: string; bio?: string }) => {
    return apiClient.put<UserProfile>('/user/profile', data);
  },

  // Get user by ID
  getUserById: (id: string) => {
    return apiClient.get<PublicUser>(`/users/${id}`);
  },

  // Search users
  searchUsers: (query: string) => {
    return apiClient.get<PublicUser[]>('/users/search', {
      params: { query }
    });
  },

  // Get all users
  getAllUsers: () => {
    return apiClient.get<PublicUser[]>('/users');
  },

  // Sync Strava activities (last 48 hours)
  syncStravaActivities: () => {
    return apiClient.post<{
      message: string;
      syncedCount: number;
      skippedCount: number;
      activities?: {
        synced: Array<{ name: string; date: Date; type: string }>;
        skipped: Array<{ name: string; date: Date; reason: string }>;
      };
      errors?: string[];
    }>('/user/sync-strava');
  },

  // Disconnect Strava account
  disconnectStrava: () => {
    return apiClient.post<{
      success: boolean;
      message: string;
      warning?: boolean;
    }>('/user/disconnect-strava');
  }
};